module.exports = __webpack_public_path__ + "static/media/nappydancers.38eddd76.jpg";